import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const SnoozeGroupPermissionGate = (props: Omit<BasePermissionGateProps<"snooze">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="snooze"
		/>
	)
}

export default SnoozeGroupPermissionGate
